import React from "react";
import Grid from "@material-ui/core/Grid";
import arrowUp from "../assets/arrow-up.png";
import arrowDown from "../assets/arrow-down.png";
import "../styles/selectProgram.css";
import Clock from "../assets/clock-icon.png";
import turn from "../assets/turn.png";
import next from "../assets/next.png";
import arrowNext from "../assets/arrowNext.png";
import back from "../assets/back.png";
import { useHistory } from "react-router-dom";

function TurnProduct() {
  let history = useHistory();
  const [powerGrill, setPowerGrill] = React.useState([
    {
      id: 0,
      active: true,
    },
    {
      id: 1,
      active: true,
    },
    {
      id: 2,
      active: true,
    },
    {
      id: 3,
      active: false,
    },
    {
      id: 4,

      active: false,
    },
    {
      id: 5,
      active: false,
    },
    {
      id: 6,
      active: false,
    },
    {
      id: 7,
      active: false,
    },
    {
      id: 8,
      active: false,
    },
    {
      id: 9,

      active: false,
    },
    {
      id: 10,
      active: false,
    },
    {
      id: 11,
      active: false,
    },
    {
      id: 12,
      active: false,
    },
    {
      id: 13,
      active: false,
    },
    {
      id: 14,
      active: false,
    },
  ]);

  return (
    <Grid
      container
      style={{
        border: "2px solid #737374",
        height: "100%",
      }}
    >
      <Grid
        onClick={() => {
          history.goBack();
        }}
        item
        xs={12}
        sm={4}
        md={2}
        className="btn"
        style={{
          border: "2px solid #737374",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: 25,
        }}
      >
         <img style={{ marginLeft: 10 }} width="80px" src={back} alt="" />
        <p style={{ marginLeft: 10 }}>Hold Knoob for 3 sec</p>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={8}
        style={{
          border: "2px solid #737374",
        }}
      >
        <p className="title">Turn Product</p>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          border: "2px solid #737374",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: 25,
        }}
      >
        <img
          className="btn"
          width="80px"
          style={{ marginLeft: 20, marginRight: 20, borderRadius: 20 }}
          src={next}
          alt=""
        />
        <p>Click Dial</p>
      </Grid>

      <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          border: "2px solid #737374",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: 25,
        }}
      >
        <img
          onClick={() => {}}
          style={{
            margin: 70,
          }}
          width="70px"
          src={arrowUp}
          alt=""
        />

        {powerGrill
          .sort((a, b) => b.id - a.id)
          .map((item, index) => {
            return item.active === true ? (
              <div
                key={index}
                style={{
                  border: "2px solid #737374",
                  width: "200px",
                  height: "15px",
                  borderRadius: 20,
                  marginTop: 8,
                  backgroundColor: "#737374",
                }}
              ></div>
            ) : (
              <div
                key={index}
                style={{
                  border: "2px solid #737374",
                  width: "200px",
                  height: "15px",
                  borderRadius: 20,
                  marginTop: 8,
                }}
              ></div>
            );
          })}

        <img
          onClick={() => {}}
          style={{
            margin: 70,
          }}
          width="70px"
          src={arrowDown}
          alt=""
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={8}
        style={{
          border: "2px solid #737374",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={turn} width={300} alt="" />
        <p style={{fontSize: 30, borderBottom: "1px solid "}}>Flip to the other side</p>
      </Grid>

      <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          border: "2px solid #737374",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <img src={arrowNext} width={50} alt="" />
        <p style={{ fontSize: 35, textAlign: "center" }}>Next Step</p>
      </Grid>
    </Grid>
  );
}

export default TurnProduct;
